import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private get isProduction(): boolean {
    return environment.production;
  }

  debug(...args: unknown[]): void {
    if (!this.isProduction) {
      console.debug(...args);
    }
  }

  info(...args: unknown[]): void {
    if (!this.isProduction) {
      console.info(...args);
    }
  }

  warn(...args: unknown[]): void {
    if (!this.isProduction) {
      console.warn(...args);
    }
  }

  error(...args: unknown[]): void {
    if (!this.isProduction) {
      console.error(...args);
    }
    // In production, errors are silently suppressed from console.
    // The global ErrorHandler (Task 2) handles user-facing error reporting.
  }
}
